import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import it from '@fullcalendar/core/locales/it';

document.addEventListener("DOMContentLoaded", function () {
    const calendarEl = document.getElementById("calendar");
    if (!calendarEl) return;

    const calendar = new Calendar(calendarEl, {
        plugins: [timeGridPlugin, listPlugin],
        allDaySlot: false,
        initialView: "timeGridWeek",
        height: "auto",
        locales: [it],
        locale: document.documentElement.lang,
        events: calendarEl.dataset.url,
        slotMinTime: "08:00:00",
        slotMaxTime: "20:00:00",
        weekends: true,
        headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "listWeek,timeGridWeek,timeGridDay",
        },
        eventClick(info) {
            info.jsEvent.preventDefault();
            window.API.openEvent(info.event.url);
        },
        eventDidMount(info) {
            const box = info.el.querySelector(".fc-event-main");
            const dot = info.el.querySelector(".fc-list-event-dot");
            if (box) box.style.backgroundColor = info.event.backgroundColor;
            if (dot) dot.style.borderColor = info.event.backgroundColor;
            if (info.event.extendedProps.subscribed) {
                if (box) box.style.backgroundColor = "#1c701c";
                if (dot) dot.style.borderColor = "#1c701c";
            }
        },
    });
    calendar.render();
});
